import { EntityTypeOld, INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import {
  AkaCriticalIllness,
  AkaGroupLifeCompositions,
  AkaGroupLifeCoverage,
  CriticalIllnessCoverage,
  DeathCoverage,
  DisabilityCoverage,
} from "Store/interfaces/products/coverage";

import { AdviceProductDetailsBackendValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { Cart } from "Store/cart/cartInterfaces";
import { AdvicePriceRequest } from "./AdviceProductPriceRequests";
import { CollectiveAdvice } from "./CollectiveAdvice";

export interface AdviceStartPayload {
  adviceProductDetailsBackendValues: AdviceProductDetailsBackendValues;
  isCollectiveAdvice: boolean;
}

export interface GetEditedAkaAdvicePayload {
  isCollectiveAdvice: boolean;
  cart: Cart;
}

export interface AdviceState {
  adviceResult: AdviceResponseEntity;
  advicePriceCalculationResults: AdvicePriceCalculationResponseEntity;
}

type AdviceResponseEntity = EntityTypeOld<CollectiveAdvice, OperationType>;

export interface AdvicePriceCalculationRequest {
  productPriceUrl: string;
  insuranceName: INSURANCE_NAME_VALUE;
  data: AdvicePriceRequest;
}

type AdvicePriceCalculationResponseEntity = EntityTypeOld<
  AdvicePriceCalculationResult[],
  OperationType
>;

export enum OperationType {
  SEND_GET_ADVICE_REQUEST = "SEND_GET_ADVICE_REQUEST",
  SEND_ADVICE_PRICE_CALCULATION_REQUEST = "SEND_ADVICE_PRICE_CALCULATION_REQUEST",
  SEND_CUSTOMER_PRICE_CALCULATION_REQUEST = "SEND_CUSTOMER_PRICE_CALCULATION_REQUEST",
  UPDATE_ADVICE_IN_CART_REQUEST = "UPDATE_ADVICE_IN_CART_REQUEST",
}

export interface AdvicePriceCalculationResult {
  configurationName: AdviceCoverageName;
  composites: Record<AkaGroupLifeCompositions, { prices: Price[] }>;
  compositions: string[];
  prices: Price[];
}

export interface Price extends AkaMemberCoInsuredPrice {
  monthlyPrice: number;
  monthlyPricePrecise: number;
  yearlyPrice: number;
  yearlyPricePrecise: number;
  fullMonthlyPrice: number;
  fullMonthlyPricePrecise: number;
  fullYearlyPrice: number;
  fullYearlyPricePrecise: number;
}

interface AkaMemberCoInsuredPrice {
  memberMonthlyPrice?: number;
  memberMonthlyPricePrecise?: number;
  memberYearlyPrice?: number;
  memberYearlyPricePrecise?: number;
  coInsuredMonthlyPrice?: number;
  coInsuredMonthlyPricePrecise?: number;
  coInsuredYearlyPrice?: number;
  coInsuredYearlyPricePrecise?: number;
}

export type AdviceCoverageName =
  | AkaGroupLifeCoverage
  | AkaCriticalIllness
  | DeathCoverage
  | DisabilityCoverage
  | CriticalIllnessCoverage;
